import React from "react";
import { Modal, Box, Typography, Table, TableBody, TableCell, TableContainer, TableRow, Paper, IconButton, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const TotalAmountDetailsModal = ({ open, handleClose, orderhistorylogdetailsamount }) => {
    const { totalVat, totalSd, totalWithdrawn, totalRefund } = orderhistorylogdetailsamount || {};
    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 400, borderRadius: 2 }}>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', fontWeight: 600, mb: 2, pb: 2, borderBottom: '2px dashed gray' }}>Orders Info</Typography>
                <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
                    <Table size="medium">
                        <TableBody>
                            <TableRow>
                                <TableCell align="left" sx={{ fontWeight: 500, border: 0 }}>Total VAT</TableCell>
                                <TableCell align="right" sx={{ border: 0 }}>
                                    {totalVat !== undefined ? "£" + totalVat.toFixed(2) : <CircularProgress size={18} thickness={5} />}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="left" sx={{ fontWeight: 500, border: 0 }}>Total SD</TableCell>
                                <TableCell align="right" sx={{ border: 0 }}>
                                    {totalSd !== undefined ? "£" + totalSd.toFixed(2) : <CircularProgress size={18} thickness={5} />}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="left" sx={{ fontWeight: 500, border: 0 }}>Total Withdrawn</TableCell>
                                <TableCell align="right" sx={{ border: 0 }}>
                                    {totalWithdrawn !== undefined ? "£" + totalWithdrawn.toFixed(2) : <CircularProgress size={18} thickness={5} />}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="left" sx={{ fontWeight: 500, border: 0 }}>Total Refund</TableCell>
                                <TableCell align="right" sx={{ border: 0 }}>
                                    {totalRefund !== undefined ? "£" + totalRefund.toFixed(2) : <CircularProgress size={18} thickness={5} />}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Modal>
    )
}

export default TotalAmountDetailsModal;